import React from "react";
import { Modal } from "react-bootstrap";
import { useStateContext, currentMode } from "../../contexts/ContextProvider";
import RoleManagementForm from "../RoleManagementForm";
const RoleManagement = ({
  showRoleManagementForm,
  closeModel,
  roles,
  handleAddRole,
  handleUpdateRole,
}) => {
  const { currentColor, currentMode } = useStateContext();
  return (
    <Modal
      show={showRoleManagementForm}
      // onHide={() => {
      //   closeModel();
      // }}
      size="xxl-down"
      centered
      backdrop="static"
      keyboard={false}
      className="modal-dialog-centered"
    >
      <Modal.Header
        className={`  ${
          currentMode === "Dark"
            ? "text-white bg-[#33373E]"
            : "bg-gray-200 border-b border-gray-300  "
        }`}
        // closeButton
        style={{ borderRadius: "none" }}
      >
        <Modal.Title className="text-md font-semibold w-full">
          <div className="flex mt-0 justify-between items-center">
          <div className="flex items-center" style={{ width: "100%" }}>
            {/* <img
            src="/icons/client-icon.svg"
            alt="icon"
            className="w-10 h-10"
          /> */}
            <span
              style={{
                mask: `url(/icons/Add-user-role.svg) center no-repeat`,
                WebkitMask: `url(/icons/Add-user-role.svg) center no-repeat`,
                maskSize: "contain", // Adjust the mask size here
                WebkitMaskSize: "contain",
                display: "block",
                width: "35px",
                height: "35px",
                backgroundColor: currentColor,
                transition: "background-color 0.3s",
                marginRight: "8px",
              }}
            ></span>
            <h5 className="mt-2">Role Management</h5>
            
          </div>
          <div className="flex justify-end" onClick={closeModel}>
              <span
                style={{
                  mask: `url(/icons/close.svg) center no-repeat`,
                  WebkitMask: `url(/icons/close.svg) center no-repeat`,
                  maskSize: "contain", // Adjust the mask size here
                  WebkitMaskSize: "contain",
                  display: "block",
                  width: "25px",
                  height: "25px",
                  backgroundColor: currentColor,
                  transition: "background-color 0.3s",
                  marginRight: "8px",
                  cursor: "pointer",
                }}
              ></span>
            </div>
            </div>

        </Modal.Title>
      </Modal.Header>
      <Modal.Body  className={`overflow-auto p-6 ${
            currentMode === "Dark"
              ? "text-white bg-[#33373E]"
              : "bg-white border"
          }`}>
        <RoleManagementForm
          roles={roles}
          handleAddRole={handleAddRole}
          handleUpdateRole={handleUpdateRole}
          closeModal={closeModel}
        />
      </Modal.Body>
    </Modal>
  );
};

export default RoleManagement;
